// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4dda0225","488":"fa248a03","650":"7f596521"}[chunkId] + ".chunk.js";
};